import swal from "sweetalert2";

/**
 * 
 * @param currentTimezoneCode - timezone code of report
 * @param newTimezoneCode - new timezone code of selected entity
 */

export async function notifyFormTimezoneError(currentTimezoneCode, newTimezoneCode) {
	try {
		await swal.fire({
			title: "Unexpected report timezone",
			html:
				`This report's timezone is currently ${currentTimezoneCode}, while the 
				form's timezone is ${newTimezoneCode}. <br/><br/>
				The system is unable to resolve this discrepancy.`,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			showConfirmButton: true,
			type: "error"
		});
	}
	catch(err) {
		return false;
	}
}

export async function notifyUserTimezoneError() {
	try {
		await swal.fire({
			title: "Unexpected form time mode",
			html:
				"This form uses a 'ByUser' time mode, which is not currently supported",
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			showConfirmButton: true,
			type: "error"
		});
	}
	catch(err) {
		return false;
	}
}

/**
 * 
 * @param fieldName - name of entity field
 */
export async function notifyMultipleEntityTimezoneError(fieldName) {
	try {
		await swal.fire({
			title: "Multiple timezones detected",
			html:
				`The selected ${fieldName} is associated with multiple timezones. Please correct before proceeding`,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			showConfirmButton: true,
			type: "error"
		});
	}
	catch(err) {
		return false;
	}
}

/**
 * 
 * @param fieldName - name of entity field
 */
export async function notifyNoEntityTimezoneError(fieldName) {
	try {
		await swal.fire({
			title: "No timezones detected",
			html:
				`The selected ${fieldName} is not associated with any timezones. Please correct before proceeding`,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			showConfirmButton: true,
			type: "error"
		});
	}
	catch(err) {
		return false;
	}
}